/* vg-fly-to-cart.js - fotka produktu odleti do kosiku
   ==================================================
   Vygruntujeme.cz, 2026-08-23. Obraceny let (odebrani) 2026-08-25.

   CO DELA: po pridani zbozi do kosiku se z fotky produktu odlepi jeji
   kopie, letí po oblouku k ikone kosiku v zahlavi, cestou se zmensuje a
   mizi; kosik na konci lehce poskoci.

   OBRACENY SMER (zadani klienta 2026-08-25): pri odebrani minusem nebo
   kosem ([data-vg-qty="down"]) letí tataz kopie opacne - vyleti z ikony
   kosiku (pripadne z docasneho plovouciho kosiku) a po stejnem oblouku
   se vrati na fotku produktu, cestou se zvetsuje. Cislo v plovoucim
   kosiku klesne v okamziku, kdy kopie kosik opousti - zrcadlove k
   pridani, kde se navysi az dopadem. Viz flyBack nize.

   PROC: pri pridani se doted vizualne skoro nic nestalo - jen se nekde
   prepsalo cislo. Zvlast u pocitadla na karte zakaznik nepoznal, jestli
   se klik povedl. Tohle je odpoved "ano, pridal jsem, a tamhle to je".

   ZADNY GENIE JAKO NA MACU: to zakrivene protazeni je zkresleni plochy,
   ktere prohlizec neumi. Tohle je bezny "fly to cart" - vizualne to
   plni tentyz ucel.

   DVE VECI, KTERE SI KLIENT VYSLOVNE PRAL A NESMI SE ZTRATIT:
   1. KRATKE. 480 ms. Delsi animace vypada poprve hezky a podesate
      otravuje.
   2. NEHROMADI SE. Kdyz nekdo tri krat tukne na plus, letí jedna kopie,
      ne tri - hlida to priznak `flying`.

   Kdo ma v systemu zapnute omezeni pohybu, uvidi jen poskoceni kosiku.
   Animace nikdy nezasahuje do pridavani samotneho: posluchac nic neruší
   ani neodklada, jen kresli. */
(function () {
  'use strict';

  if (window.vgFlyToCartLoaded) return;
  window.vgFlyToCartLoaded = true;

  var DURATION = 700;
  var flying = false;
  /* Po dobu letu se cislo v plovoucim kosiku nesmi prepsat zvenci -
     jinak by ho potvrzeni ze serveru mohlo navysit driv, nez kopie
     dorazi, a zmena by nebyla videt. Viz syncCartFull nize. */
  var holdChipCount = false;

  var ICON_CART =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="9" cy="20" r="1.6"/><circle cx="18" cy="20" r="1.6"/>' +
    '<path d="M2 3h2.2l2.4 12.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.3L21 7H5"/>' +
    '</svg>';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Ikon kosiku je v DOM vic (zvlast pro mobilni a desktopove zahlavi) a
     ta nespravna je schovana pres display: none. Vybira se proto podle
     toho, ktera ma nenulove rozmery, ne podle pevneho selektoru - jinak
     by kopie na mobilu letela do praveho horniho rohu naslepo. */
  function cartTarget() {
    var marks = document.querySelectorAll('[data-header-cart-count]');
    for (var i = 0; i < marks.length; i++) {
      var el = marks[i].closest('a, button') || marks[i];
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return el;
    }
    return null;
  }

  /* Fotka se hleda od nejblizsiho obalu produktu smerem ven, aby se u
     doporucenych produktu nechytla fotka hlavniho produktu. */
  function sourceImage(btn) {
    var scopes = [
      btn.closest('.product-related-item'),
      btn.closest('.product-item'),
      btn.closest('.vg-detail-buy') ? document.querySelector('.main-product .product-gallery-item') : null,
      btn.closest('.main-product') ? document.querySelector('.main-product .product-gallery-item') : null
    ];
    for (var i = 0; i < scopes.length; i++) {
      if (!scopes[i]) continue;
      var img = scopes[i].querySelector('img');
      if (img && img.getBoundingClientRect().width > 0) return img;
    }
    return null;
  }

  function bump(el) {
    if (!el) return;
    el.classList.remove('vg-cart-bump');
    /* Vynucene prekresleni - bez nej by odebrani a nasazeni tride
       v jednom kroku prohlizec sloucil a animace by se nespustila. */
    void el.offsetWidth;
    el.classList.add('vg-cart-bump');
    setTimeout(function () { el.classList.remove('vg-cart-bump'); }, 560);
  }

  /* --- docasny kosik vpravo nahore --------------------------------
     Zadani klienta 2026-08-23: kdyz je stranka odrolovana a kosik v
     zahlavi neni videt, ma se "na chvili vysunout" jen kvuli tomu
     efektu a zase zmizet.

     Bez toho letela kopie do souradnic mimo obrazovku - klient to
     popsal jako "letí vodorovne nahoru" a byl to presne tenhle pripad.
     Orezani souradnice do rohu (prvni pokus) problem neresilo: kopie
     sice zustala v obrazovce, ale koncila v prazdnem rohu, kde nic
     neni. Tohle uz je terč, na ktery se da mirit.

     Pocet se opise z odznacku v zahlavi, aby cislo sedelo. */
  /* Pocet v zahlavi. Vsechny odznacky se prepisuji naraz (obnova kosiku
     v assets/vg-card-grid.js projde querySelectorAll), takze staci cist
     prvni z nich - i ten schovany nese aktualni hodnotu. */
  function headerCount() {
    var mark = document.querySelector('[data-header-cart-count]');
    if (!mark) return 0;
    var n = parseInt((mark.textContent || '').replace(/\D+/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function setChipCount(n) {
    var chip = document.querySelector('.vg-cart-chip');
    if (!chip) return;
    var el = chip.querySelector('.vg-cart-chip__n');
    if (el) el.textContent = n > 0 ? String(n) : '';
  }

  function floatingTarget() {
    var chip = document.querySelector('.vg-cart-chip');
    if (!chip) {
      chip = document.createElement('div');
      chip.className = 'vg-cart-chip';
      chip.innerHTML = ICON_CART + '<span class="vg-cart-chip__n"></span>';
      document.body.appendChild(chip);
    }
    /* KOSIK VYLEZE JESTE SE STARYM POCTEM. Zadani klienta 2026-08-23:
       "vidim porad puvodni pocet, pak tam prileti novy produkt a cislo
       se navysi, at vidim tu zmenu." Navyseni proto delá az dopad kopie
       (viz done nize), ne vysunuti.

       Odznacek v zahlavi se prepise az po odpovedi serveru, takze se na
       nej cekat neda - hodnota po pridani se dopocita. */
    setChipCount(headerCount());
    /* Vynucene prekresleni, aby se prechod spustil i kdyz prvek vznikl
       az ted - jinak by prohlizec pocatecni a koncovy stav sloucil. */
    void chip.offsetWidth;
    chip.classList.add('is-in');
    return chip;
  }

  function hideFloating() {
    var chip = document.querySelector('.vg-cart-chip');
    if (!chip) return;
    chip.classList.remove('is-in');
  }

  /* Terč letu je VZDY docasny plovouci kosik (zadani klienta
     2026-08-25): drive kopie mirila na ikonu v zahlavi, kdyz byla
     videt - klient ale chce, aby produkt neletel "do listy", nybrz do
     kosiku, ktery z ni vpravo nahore kousek vyjede. Plovouci kosik se
     proto vysune pri kazdem letu a po dopadu se zase zasune. Ikona v
     zahlavi zustava terc jen pro bump pri zapnutem omezeni pohybu
     (viz fly/flyBack), tam se nic nevysouva. */
  function pickTarget() {
    return { el: floatingTarget(), temp: true };
  }

  function fly(btn) {
    if (reducedMotion()) {
      var t0 = cartTarget();
      if (t0) bump(t0);
      return;
    }
    if (flying) return;

    var img = sourceImage(btn);
    if (!img) return;

    var from = img.getBoundingClientRect();
    if (!from.width) return;

    var startCount = headerCount();
    var picked = pickTarget();
    var target = picked.el;
    var to = target.getBoundingClientRect();
    if (!to.width) return;
    if (picked.temp) holdChipCount = true;

    flying = true;

    var ghost = document.createElement('div');
    ghost.className = 'vg-fly';
    ghost.style.left = from.left + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    ghost.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
    document.body.appendChild(ghost);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

    /* Prostredni snimek je zamerne vys nez primka mezi body (o 60 px) -
       tim vznikne oblouk. Primy let pusobi mechanicky. */
    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 70) + 'px) scale(.55)', opacity: .9, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: .2 }
    ], { duration: DURATION, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' });

    function done() {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      flying = false;
      /* Poradi je zamerne: nejdriv se prepise cislo, hned po nem
         poskoci kosik. Cislo se tim meni presne v okamziku dopadu. */
      if (picked.temp) {
        holdChipCount = false;
        setChipCount(startCount + 1);
      }
      bump(target);
      /* Docasny kosik chvili zustane, at je zmena i poskoceni videt, a
         pak se zase zasune. Skutecna ikona v zahlavi se nikam neschovava. */
      if (picked.temp) setTimeout(hideFloating, 1400);
    }
    anim.onfinish = done;
    /* Pojistka: kdyby onfinish nedorazil (prepnuta zalozka animaci
       pozastavi), kopie by zustala viset pres celou stranku. */
    setTimeout(function () { if (flying) done(); }, DURATION + 400);
  }

  /* --- obraceny let: zbozi se vraci z kosiku na kartu ---------------
     (zadani klienta 2026-08-25)

     Zrcadlo funkce fly: kopie fotky startuje malinka na ikone kosiku
     (nebo na docasnem plovoucim kosiku, kdyz je zahlavi odrolovane),
     letí po stejnem oblouku zpatky a dosedne presne na fotku produktu.
     Na konci se jen odebere - pod ni uz je ta skutecna fotka, takze
     zadne mizeni neni videt.

     POCET KLESA PRI STARTU, NE PRI DOPADU. U pridani chtel klient videt
     zmenu az dopadem ("prileti a cislo se navysi"). U odebrani je to
     naopak - zbozi kosik OPOUSTI, takze cislo klesne v okamziku odletu.
     Drobne zpozdeni 200 ms je tam jen proto, aby se plovouci kosik
     stihl vysunout jeste se starym cislem a pokles byl videt.

     Sdili se priznak `flying` s pridavanim - v jednu chvili leti vzdy
     jen jedna kopie, at se kliky nehromadi (pozadavek klienta c. 2 z
     hlavicky souboru). Do mazani samotneho se nezasahuje: obsluhu ma
     assets/vg-card-grid.js (change/flushOne), tady se jen kresli. */
  function flyBack(btn) {
    if (reducedMotion()) {
      var t1 = cartTarget();
      if (t1) bump(t1);
      return;
    }
    if (flying) return;

    var img = sourceImage(btn);
    if (!img) return;

    var to = img.getBoundingClientRect();
    if (!to.width) return;

    /* ZADNA KONTROLA MNOZSTVI NA PILULCE. Puvodne tu byl test
       data-qty > 0, jenze obsluha kosiku v assets/vg-card-grid.js bezi
       na tyz klik driv (oba posluchace jsou capture na dokumentu a jeji
       je registrovana drive) a change() SYNCHRONNE prekresli pilulku -
       pri odebrani posledniho kusu tu uz stalo data-qty="0" a let se
       zahodil. Presne tenhle pripad (kos, 1 -> 0) je pritom ten hlavni.
       Kontrola neni potreba: pri nule je pilulka schovana (CSS pres
       vg-has-qty), takze na minus ani kos nejde kliknout. */

    var startCount = headerCount();
    var picked = pickTarget();
    var target = picked.el;
    var from = target.getBoundingClientRect();
    if (!from.width) return;
    if (picked.temp) holdChipCount = true;

    flying = true;

    /* Kopie ma od zacatku rozmery a pozici CILE (fotky na karte);
       na start do kosiku ji posune pocatecni transform. Diky tomu
       dosedne na fotku bez prepocitavani. */
    var ghost = document.createElement('div');
    ghost.className = 'vg-fly';
    ghost.style.left = to.left + 'px';
    ghost.style.top = to.top + 'px';
    ghost.style.width = to.width + 'px';
    ghost.style.height = to.height + 'px';
    ghost.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
    document.body.appendChild(ghost);

    var dx = (from.left + from.width / 2) - (to.left + to.width / 2);
    var dy = (from.top + from.height / 2) - (to.top + to.height / 2);

    bump(target);
    /* Pokles cisla tesne po startu - viz komentar nad funkci. */
    if (picked.temp) {
      setTimeout(function () {
        setChipCount(startCount - 1);
      }, 200);
    }

    /* Stejny oblouk jako pri pridani, jen pozpatku - prostredni snimek
       je o 70 px vys nez primka mezi body. */
    var anim = ghost.animate([
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: .2 },
      { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 70) + 'px) scale(.55)', opacity: .9, offset: .45 },
      { transform: 'translate(0,0) scale(1)', opacity: 1 }
    ], { duration: DURATION, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' });

    function done() {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      flying = false;
      if (picked.temp) {
        /* Od ted smi cislo zase prepisovat server (syncCartFull) -
           potvrzena hodnota po odebrani uz je stejna nebo nizsi. */
        holdChipCount = false;
        setTimeout(hideFloating, 1400);
      }
    }
    anim.onfinish = done;
    /* Stejna pojistka jako u fly - viz tam. */
    setTimeout(function () { if (flying) done(); }, DURATION + 400);
  }

  /* --- pulzovani kosiku, kdyz v nem neco je ------------------------
     Zadani klienta 2026-08-23. Trida se jen nasazuje a sunda, samotny
     pohyb je v assets/vg-card-grid.css sekci 32.

     Pocet se cte z odznacku v tlacitku. Zamerne se nebere jen cislice:
     motiv tam u prazdneho kosiku nechava nulu, takze "je tam neco" musi
     znamenat > 0, ne "neco je napsano".

     Pozorovatel je nutny - obsah odznacku prepisuje jak sablona, tak
     nase obnova kosiku po pridani, a to kdykoli po nacteni stranky. */
  function syncCartFull() {
    var btn = document.querySelector('.mobile-cart-button');
    if (!btn) return false;
    var mark = btn.querySelector('[data-header-cart-count]');
    var n = mark ? parseInt((mark.textContent || '').replace(/\D+/g, ''), 10) : 0;
    if (isNaN(n)) n = 0;
    btn.classList.toggle('vg-cart-full', n > 0);
    /* Kdyz je zrovna venku plovouci kosik, dorovna se v nem cislo na
       potvrzenou hodnotu - ale az po dopadu kopie. Behem letu ma prednost
       stary pocet, aby bylo navyseni videt. */
    if (!holdChipCount) setChipCount(n);
    return true;
  }

  function watchCartCount() {
    var btn = document.querySelector('.mobile-cart-button');
    if (!btn) return false;
    syncCartFull();
    new MutationObserver(syncCartFull).observe(btn, {
      childList: true, subtree: true, characterData: true
    });
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (!watchCartCount()) setTimeout(watchCartCount, 800);
    });
  } else {
    if (!watchCartCount()) setTimeout(watchCartCount, 800);
  }

  /* Zachytava se ve fazi capture, aby se kresleni spustilo i tehdy, kdyz
     nektery jiny posluchac klik zastavi. Odkazy (<a>) se preskakuji -
     u vicevariantnich produktu vede tlacitko na detail, nic se nepridava. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    /* Odebrani (minus i kos) ma prednostni vetev - obraceny let. */
    var down = e.target.closest('[data-vg-qty="down"]');
    if (down && !down.disabled) {
      flyBack(down);
      return;
    }

    var btn = e.target.closest('.vg-cart-icon-btn, [data-vg-qty="up"], .add-to-cart');
    if (!btn) return;
    if (btn.tagName === 'A') return;
    if (btn.disabled) return;

    fly(btn);
  }, true);
})();
